import { Component, OnInit, ViewChild, AfterViewInit, ElementRef, Renderer2 } from '@angular/core';
//import { FormConfig } from '../../../types/Forms';
//import { enumValues } from '../../../utils/enum-values';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { Ng2TelInput } from 'ng2-tel-input';
import { HEALTH_CARE_PROVIDER, CLINICIAN, DISPLAY_DOB, INPUT_DATE_FORMAT, FIFTY_FIVE_YEARS_AGO } from '../../../utils/constants';
import { Gender, GENDERS } from '../../../types/Gender';
import { AlertService } from '../../../services/alert.service';
import { Title } from '@angular/platform-browser';
import { LoadingService } from '../../../services/loading.service';
import { AuthService } from '../../../services/auth.service';
import { ValidationUtil, Validator } from '../../../utils/validation';
//import { focusOnInput } from '../../../utils/focus-on-input';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
//import { SiteModalPage } from '../site-modal/site-modal';
import { Capacitor } from '@capacitor/core';
import { SiteModalPage } from './site-modal/site-modal';
import { AnalyticsService } from 'src/app/services/analytics.service';


export enum RegisterFieldsPage1 {
  FIRST = 'first',
  LAST = 'last',
  DOB = 'dob',
  GENDER = 'gender'
}

export enum RegisterFieldsPage2 {
  PHONE = 'phone',
  SITE = 'site',
}


type RegisterFormConfig = {
  [index in RegisterFieldsPage1 | RegisterFieldsPage2]: [string, Validator[]] | FormControl
};

@Component({
  selector: 'app-register',
  templateUrl: './register.page.html',
  styleUrls: ['./register.page.scss', '../authentication.scss'],
})
export class RegisterPage implements OnInit, AfterViewInit {

  title = 'Register';
  registerForm: FormGroup;

  maxDateStr: string;

  @ViewChild(Ng2TelInput, { static: true })
  phoneNumber!: Ng2TelInput;
  @ViewChild('phoneNumber', { static: true })
  phoneNumberEl!: ElementRef;

  isValid!: boolean;
  errorMessage!: string;
  normalizedPhoneNumber!: string;
  phone: any;
  dobDisplay: string = DISPLAY_DOB;
  healthCareProvider: string = HEALTH_CARE_PROVIDER;
  clinician: string = CLINICIAN;
  genders: Gender[] = GENDERS;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public alertProvider: AlertService,
    private docTitle: Title,
    private formBuilder: FormBuilder,
    private modalCtrl: ModalController,
    private loadingProvider: LoadingService,
    private amplifyProvider: AuthService,
    private renderer: Renderer2,
    private analyticsService: AnalyticsService,
  ) {
    this.analyticsService.tagRoute('unauthenticated/register');
    this.maxDateStr = moment().startOf('day').format(INPUT_DATE_FORMAT);
    const defaultDateStr = FIFTY_FIVE_YEARS_AGO;

    const formConfig: RegisterFormConfig = {
      first: ['', [ValidationUtil.isRequired]],
      last: ['', [ValidationUtil.isRequired]],
      dob: [
        defaultDateStr,
        [ValidationUtil.isRequired, ValidationUtil.dateInPast]
      ],
      gender: ['', [ValidationUtil.isRequired]],
      phone: ['', [ValidationUtil.isRequired]],
      site: ['', [ValidationUtil.isRequired]]
    };

    this.docTitle.setTitle(this.title);
    this.registerForm = this.formBuilder.group(formConfig);
  }

  ng2TelCustomOptions = {
    initialCountry: 'au',
    utilsScript: 'utils.js',
    customPlaceholder: (selectedCountryPlaceholder: any) => {
      return 'e.g. ' + selectedCountryPlaceholder;
    },
  };

  ngAfterViewInit() {
    this.phoneNumberEl.nativeElement.dispatchEvent(new Event('keyup'));
    const phone = this.renderer.selectRootElement('input[ng2telinput]');
    setTimeout(() => {
      if (phone) {
        phone.focus();
      }
    }, 1000);
  }

  ngOnInit() {
    this.route.queryParamMap.subscribe(params => {
      this.phone = params.get('phone');
      this.registerForm.controls['phone'].setValue(this.phone);
    });
  }

  submitForm(): void {
    this.normalizedPhoneNumber = this.phoneNumber.ngTelInput.getNumber();
    const singleUsePassword = this.amplifyProvider.generateNewPassword();
    this.loadingProvider.loadWhile(async (stopLoading) => {
      try {
        const formData = this.registerForm.value;
        const birthdate = moment(formData.dob).format('YYYY-MM-DD');
        const registerData = {
          phone_number: this.normalizedPhoneNumber,
          password: singleUsePassword,
          given_name: formData.first.trim(),
          family_name: formData.last.trim(),
          birthdate,
          gender: formData.gender,
          'custom:sitecode': formData.site.toLowerCase().trim()
        };
        await this.amplifyProvider.registerUser(registerData);
        if (Capacitor.isNativePlatform()) {
          this.router.navigate(['unauthenticated', 'verifysignup'], { queryParams: { phone: this.normalizedPhoneNumber }});
        } else {
          await this.amplifyProvider.sendSMSCode(this.normalizedPhoneNumber);
          this.router.navigate(['unauthenticated', 'verifysignup'], { queryParams: { phone: this.normalizedPhoneNumber }});
        }

      } catch (error) {
        this.handleError(error);
      } finally {
        stopLoading();
      }
    });
  }

  handleError(error: any) {
    if (this.amplifyProvider.isUsernameExistsException(error)) {
      this.handleUsernameExistsException(error);
    } else if (this.amplifyProvider.isUserLambdaValidationException(error)) {
      this.handleValidationException(error);
    } else {
      this.alertProvider.showAmplifyAuthError(error);
    }
  }

  handleUsernameExistsException(error: any) {
    console.error(error);
    const registeredPhoneNumber = this.registerForm.controls['phone'].value;
    this.alertProvider.confirm(
      `This mobile number is already registered`,
      `Check your number and try again. Alternative contact support@cardihab.com`,
      `Go to Login`,
      () => {
        this.router.navigate(['unauthenticated', 'login'], {
          queryParams: { registeredPhoneNumber }
        });
      }
    );
  }

  handleValidationException(error: any) {
    console.error(error);
    this.alertProvider.confirm(
      `Provider site not found`,
      `Please ask your ${this.healthCareProvider} or ${this.clinician} for this information.`
    );
  }

  phoneHasError(isValid: boolean) {
    this.isValid = isValid;
    if (isValid) {
      this.registerForm.controls['phone'].setErrors(null);
    } else {
      this.setErrorMessage(this.registerForm.controls['phone'].value);
    }
  }

  setErrorMessage(phoneNumber: string) {
    if (!Boolean(phoneNumber)) {
      this.errorMessage = 'Phone number is required';
      this.registerForm.controls['phone'].setErrors({ 'required': true });
    } else {
      this.errorMessage = 'Phone number is not valid';
      this.registerForm.controls['phone'].setErrors({ 'invalid': true });
    }
  }

  async showModal() {
    const modal = await this.modalCtrl.create({
      component: SiteModalPage,
    });
    await modal.present();
  }


  cancel() {
    if (this.registerForm.dirty) {
      this.showDiscardConfirmation();
    } else {
      this.analyticsService.tagButtonPress('registration', 'cancel');
      this.router.navigate(['unauthenticated', 'home']);
    }
  }

  showDiscardConfirmation(): void {
    this.alertProvider.confirmDiscard(
      'Discard unsaved changes?',
      'Do you want to discard unsaved changes?',
      'Discard',
      () => {
        this.analyticsService.tagButtonPress('registration', 'cancel');
        this.router.navigate(['unauthenticated', 'home']);
      }
    );
  }

}
